import axios from 'axios'

/***
 * @description Update quantity in basket
 * @param {number} productid
 * @param {number} quantity
 * @param {boolean} isSubscription
 * @param {number} interval
 * @param {boolean} pointshop
 */
export async function updateQuantity(productid, quantity, isSubscription = false, interval = -1, pointshop) {
    let data = {
        products: [
            { productID: productid, quantity: quantity, isSubscription: isSubscription, intervalReferenceId: interval }
        ],
        isPointShop: pointshop == true || pointshop == "Y" ? 'Y' : 'N'
    }

    if (isSubscription && interval == -1) {
        throw new Error("Interval must be set if product is subscription");
    }

    return axios.get(`${window.basedir}/ajaxRequestServlet?mode=UpdateQuantity&payload=${JSON.stringify(data)}`, {
        headers: {
            'Content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
        }
    })
}

export async function getBasket() {
    let data = { refreshBasket: 'OK', isPointShop: window.isPointShop == true || window.isPointShop == "Y"}
    return axios.get(`${window.basedir}/ajaxRequestServlet?mode=RefreshBasket&payload=${JSON.stringify(data)}`);
}

export function refreshBasket() {
    window.ajaxBasket.refresh();
}
export async  function versionData(sku) {
    const response =  await axios.get(`${window.basedir}/ajaxRequestServlet?mode=ImageAPI&task=getProductVersions&sku_no=${sku}`, {
            headers: {
                'Content-type': 'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
    });
    return response.data;
}

export function updateImage(product) {
    if(document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2)").length) {
        const regex = /https:\/\/sg0\.pharmanord\.com\/\d+\/(\d+)\.th(\d+)?(\.png|\.webp)/;
    let match = product.imageUrl.match(regex);
    let flaptype = document.querySelectorAll(".productImg")[0].getAttribute('data-flaptype');
    
    if (match) {
        let id = match[1];

        //if the active thumbnail is the 2nd image, change that
        if (document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2)")[0].classList.contains('active')) {
            document.querySelectorAll('.galleryContainer img')[0].setAttribute('src', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`);
            //document.querySelectorAll('.galleryContainer img')[0].setAttribute('src',`${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}.th4.webp`)
            document.querySelectorAll('.fancybox')[0].setAttribute('href', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`);

        }
        //if the active thumbnail is the 1st image, change that
        if (document.querySelectorAll(".galleryThumbScroller ul li:nth-child(1)")[0].classList.contains('active')) {
            //document.querySelectorAll('.galleryContainer img')[0].setAttribute('src', `${window.basedir}/productImageServlet/ID${id}M.th4.webp`);
            document.querySelectorAll('.galleryContainer img')[0].setAttribute('src', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`);
            document.querySelectorAll('.fancybox')[0].setAttribute('href', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`);

        }

        //change first thumbnail image
        let firstThumbnail = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(1) img")[0];
        let firstThumbnailLink = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(1) a")[0];

        // firstThumbnail.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th3.webp`)
        // firstThumbnail.setAttribute('data-bigimage', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th4.webp`)
        // firstThumbnail.setAttribute('data-media', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th4.webp`)
        // firstThumbnail.setAttribute('src', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th4.webp`)

        // firstThumbnailLink.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th3.webp`)
        // firstThumbnailLink.setAttribute('href', `${window.basedir}/productImageServlet/ID${id}${flaptype}.th4.webp`)

        firstThumbnail.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)
        firstThumbnail.setAttribute('data-bigimage', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)
        firstThumbnail.setAttribute('data-media', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)
        firstThumbnail.setAttribute('src', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)

        firstThumbnailLink.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)
        firstThumbnailLink.setAttribute('href', `${window.basedir}/productImageServlet/ID${id}${flaptype}/SKU${product.sku_no}${flaptype}.th4.webp`)
        if(!use_image_old_url) { //special condition for stuff

        //change backside image
        let secondThumbnail = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2) img")[0];
        let secondThumbnailLink = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2) a")[0];

        secondThumbnail.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp?w=85&quality=50`)
        secondThumbnail.setAttribute('data-bigimage', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)
        secondThumbnail.setAttribute('data-media', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)
        secondThumbnail.setAttribute('src', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)

        secondThumbnailLink.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp?w=85&quality=50`)
        secondThumbnailLink.setAttribute('href', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)


            //change backside image
            secondThumbnail = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2) img")[0];
            secondThumbnailLink = document.querySelectorAll(".galleryThumbScroller ul li:nth-child(2) a")[0];


        secondThumbnail.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp?w=85&quality=50`)
        secondThumbnail.setAttribute('data-bigimage', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)
        secondThumbnail.setAttribute('data-media', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)
        secondThumbnail.setAttribute('src', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)

        secondThumbnailLink.setAttribute('data-thumbnail', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp?w=85&quality=50`)
        secondThumbnailLink.setAttribute('href', `${window.basedir}/productImageServlet/BACK${product.sku_no}.webp`)
        }
    }
    }
    
}

export async function getSubProducts(productid, pointshop) {
    return await axios.get(`${window.basedir}/ajaxRequestServlet?mode=GetSubProducts&productId=${productid}&isPointshop=${pointshop}`)
}
export async function getIntervals() {
    return await axios.get(`${window.basedir}/ajaxRequestServlet?mode=WebsiteSettings&task=subscriptionIntervals`);
}